import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { Navigate, Route, Routes } from "react-router-dom";

import pages from "pages/routes";

import Skeleton from "@mui/material/Skeleton";
import Error, { ErrorContainer } from "ui/Error";
import NotFoundPage from "../NotFoundPage/NotFoundPage";
import { RectSkeleton } from "ui/Skeleton";

import useAppSuggests from "hooks/useAppSuggests";
import useCheckPermissions from "hooks/useCheckPermissions";

import UsersIcon from "assets/svg/users.svg";

import path, { pathParent } from "utils/path";

function AppContent({ activated }) {
  const checkPermission = useCheckPermissions();
  const { loading } = useAppSuggests();

  if (loading) {
    return (
      <Skeleton
        width="100%"
        height="100%"
        animation="wave"
        variant="rectangular"
      />
    );
  }

  if (!activated) {
    return (
      <ErrorContainer>
        <Error
          title="User not activated"
          subTitle="User has not been activated yet. Please wait for approval."
          Icon={UsersIcon}
        />
      </ErrorContainer>
    );
  }

  const filteredRoutes = pages.filter((route) =>
    checkPermission(route.permission),
  );

  const firstPage = filteredRoutes.find((page) => page.root);

  if (!firstPage) return <NotFoundPage />;

  const addRoute = ({ path, ...pageRoute }, index) => {
    const pagePath = pathParent(path);
    return <Route key={index} path={pagePath} {...pageRoute} />;
  };

  return (
    <div className="content-layout">
      <div className="content-wrapper">
        <Suspense fallback={<RectSkeleton />}>
          <Routes>
            {filteredRoutes.map(addRoute)}
            <Route
              exact
              path="*"
              element={<Navigate to={path(firstPage.path)} />}
            />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
}

AppContent.propTypes = {
  activated: PropTypes.bool,
};

export default AppContent;
